// Let native anchor navigation scroll after releasing the mobile menu's scroll lock.
document.addEventListener('click', event => {
  const link = event.target.closest?.('header-drawer a[href*="#"]');
  if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const destination = new URL(link.href, window.location.href);
  if (destination.origin !== location.origin || destination.pathname !== location.pathname || !destination.hash) return;
  const target = document.getElementById(destination.hash.slice(1));
  const drawer = link.closest('header-drawer');
  if (!target || typeof drawer.closeMenuDrawer !== 'function') return;
  drawer.closeMenuDrawer(event);
  drawer.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'false');
  const heading = target.querySelector('h2') || target;
  heading.setAttribute('tabindex', '-1');
  heading.focus({preventScroll: true});
});
